import styled from 'styled-components';
export const ErrorImage = styled.img `
    width: 50%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%) translateX(-50%);
    left: 50%;
`;
//# sourceMappingURL=DashboardError.styled.js.map